import { saved } from 'constants/global/messages';
import type { Notification } from 'types/common/notification';

const accountUpdateSuccess: Notification = {
  id: 'account/update/success',
  type: 'success',
  content: saved('Account information'),
};

const accountEmailUpdateSuccess: Notification = {
  id: 'account/email/update/success',
  type: 'success',
  content: saved('Account email'),
};

const NOTIFICATION_ACCOUNT = {
  accountUpdateSuccess,
  accountEmailUpdateSuccess,
};

export default NOTIFICATION_ACCOUNT;
